import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableStructure from "../../CommonComponents/TableStructure";
import { getAllCountriesData } from "../../services/Countries";
import { setPreview } from "../../redux/actions/previewActions";

const CountriesTable = () => {
  const [records, setRecords] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [sortOrder, setSortOrder] = useState("asc"); // Sorting state
  const session = useSelector((state) => state.session);
  const dispatch = useDispatch();
  const limit = 50; // Number of records per page

  // Fetch projects from the API
  const fetchCountries = async (page, term) => {
    setLoading(true);
    try {
      const result = await getAllCountriesData(limit, page, term);
      if (result?.data) {
        setRecords(citationFactor(result?.data?.data || []));
        setTotalPages(Math.ceil(result?.data?.total / limit));
        setTotalRecords(result?.data?.total);

        if (result.data.page_number && parseInt(result.data.page_number) !== currentPage) {
          setCurrentPage(parseInt(result.data.page_number));
        }
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setLoading(false);
    }
  };


  const citationFactor = (data) => {
    return data?.map((item) => {
      return {
        name: item?.name,
        alias: item?.alias,
        masterlist_subtype: item?.masterlist_subtype
      }
    })
  }

  const columns = [
    {
      label: "Name",
      accessor: "name",
    },
    {
      label: "Alias",
      accessor: "alias",
    },
    {
      label: "Masterlist Subtypes",
      accessor: "masterlist_subtype",
    },
  ]

  // Handle search button click
  const handleSearch = (searchTerm) => {
    if (searchTerm.trim()) {
      isInitialLoad.current = false; // Skip the first render
      setCurrentPage(1); // Reset to page 1 for a new search
      setSearchText(searchTerm);
      fetchCountries(1, searchTerm);
    }
  };

  const sortRecords = () => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc"; // Update sortOrder first
    setSortOrder(newSortOrder);

    const sorted = [...records].sort((a, b) =>
      newSortOrder === "asc"
        ? a.name.localeCompare(b.name)
        : b.name.localeCompare(a.name)
    );

    setRecords(sorted);
  };

  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false; // Skip the first render
      fetchCountries(currentPage, searchText);
      return;
    }
    fetchCountries(currentPage, searchText);
    dispatch(setPreview(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, dispatch]);

  const handleClear = () => {
    setSearchText('');
    fetchCountries(1, "");
  };

  // Handle page changes
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(parseInt(page));
    }
  };

  return (
    <TableStructure
      isAuthenticated={session?.isAuthenticated}
      handleSearch={handleSearch}
      handleClear={handleClear}
      totalRecords={totalRecords}
      handlePageChange={handlePageChange}
      currentPage={currentPage}
      totalPages={totalPages}
      sortRecords={sortRecords}
      sortOrder={sortOrder}
      loading={loading}
      records={records}
      type="countries"
      title="Countries"
      addOption
      columns={columns}
    />
  );
};

export default CountriesTable;
